import React, { useEffect, useState } from "react";
import {
  SortableContainer,
  SortableElement,
  sortableHandle,
} from "react-sortable-hoc";
import countryToCurrency from "country-to-currency";
import { arrayMoveImmutable } from "array-move";
import Select from "react-select";
import AsyncSelect from 'react-select/async';

const currencyOptions = Object.keys(countryToCurrency).map((key) => ({
  label: countryToCurrency[key],
  value: countryToCurrency[key],
  country: key,
}));
const loadOptions = (
  inputValue,
  callback
) => {
  fetch(`/admin/users.json?query=${inputValue}`).then((resp) => resp.json()).then((users) => {
    console.log('users', users);
    callback(users.map(({id, display_name, username}) => ({value: id, label: display_name || username})))  
  })

};

const FormOwner = (props) => {
  const {
    values,
    handleChange,
    handleBlur,
    errors, touched,
    setFieldValue
  } = props;
  const defaultOwner = values.owner_id ? {value: values.owner_id, label: (values.owner_name || values.owner_id)} : null;
  const [userOptions, setUserOptions] =  useState(defaultOwner ? [defaultOwner] : [])
  const loadOptions = (
    inputValue,
    callback
  ) => {
    fetch(`/admin/users.json?query=${inputValue}`).then((resp) => resp.json()).then((users) => {
      console.log('users', users);
      const newUserOptions = users.map(({id, display_name, email}) => ({value: id, label: `${display_name}(${email})`}))
      setUserOptions([...newUserOptions]);
      callback(newUserOptions);
    })

  };
  
  const handleAssign = (item) => {
    setFieldValue('owner_id', item ? item.value : null);
  }

  return (
    <React.Fragment>
      <div className="add_utf_listing_section margin-top-45">
        <div className="utf_add_listing_part_headline_part">
          <h3>
            <i className="sl sl-icon-user"></i> Business Owner
          </h3>
        </div>
        <div className="row">
          <div className="col-md-12">
            <AsyncSelect 
              value={userOptions.find((item) => item.value === values.owner_id)}
              cacheOptions 
              loadOptions={loadOptions} 
              defaultOptions={userOptions}
              isClearable
              onChange={handleAssign}
            />

          </div>
        </div>
      </div>
      <div className="add_utf_listing_section margin-top-45">
        <div className="row">
          <div className="col-md-12 checkboxes">
          <ul>
            <li>
            <input 
                  id={`check-featured-listing`} 
                  type="checkbox" 
                  defaultChecked={!!values.featured} 
                  name="featured" value={true}
                  onChange={e => setFieldValue('featured', e.target.checked)}
                />
                <label htmlFor={`check-featured-listing`}>Featured?</label>
            </li>
            <li>
            <input 
                  id={`check-sponsor-listing`} 
                  type="checkbox" 
                  defaultChecked={!!values.sponsor} 
                  name="sponsor" value={true}
                  onChange={e => setFieldValue('sponsor', e.target.checked)}
                />
                <label htmlFor={`check-sponsor-listing`}>Sponsor Top-Ad?</label>
            </li>
          </ul>

          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default FormOwner;
